import { AuthUser } from '@/modules/auth/models/AuthUser';
import { CurrentEstate } from '@/modules/estate/models/CurrentEstate';

export default class BillingDashboardAccessService {
  static canAccessBillingDashboard(
    authUser: AuthUser,
    currentEstate?: CurrentEstate | null
  ): boolean {
    return (
      this.hasFinancialAdvisorProDashboard(authUser, currentEstate) ||
      this.hasSelfServeDashboard(currentEstate)
    );
  }

  static hasFinancialAdvisorProDashboard(
    authUser: AuthUser,
    currentEstate?: CurrentEstate | null
  ): boolean {
    return !!authUser?.isAdvisorProUser && !currentEstate;
  }

  static hasSelfServeDashboard(currentEstate?: CurrentEstate | null): boolean {
    return !!currentEstate?.isSelfServe;
  }
}
